import { render, staticRenderFns } from "./DrawerVcDemo.vue?vue&type=template&id=77ddffaa&scoped=true&"
import script from "./DrawerVcDemo.vue?vue&type=script&lang=js&"
export * from "./DrawerVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./DrawerVcDemo.vue?vue&type=style&index=0&id=77ddffaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ddffaa",
  null
  
)

export default component.exports